module.exports = __webpack_public_path__ + "img/album6.f7344b96.jpg";